// 修改性别弹窗
import { Modal, Form, Radio, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import DialogHeading from '@/components/dialogheading';
import './ProfileEditors.scss';
import { fetchModifyUserInfo, fetchUserInfo } from '@/apis/user';
import { useSelector, useDispatch } from 'react-redux';

const EditGenderModal = ({ genderOpen, setGenderOpen }) => {
  // 配置初始化
  const dispatch = useDispatch();
  const [genderForm] = Form.useForm();
  const { userInfo } = useSelector(state => state.user);
  // 用户点击确认后处理请求
  const onGenderCreate = async (values) => {
    // 关闭弹窗
    setGenderOpen(false);
    try {
      // 提交修改
      const result = await fetchModifyUserInfo(values, userInfo.username);
      // 修改成功后，重新拉用户信息
      if (result.success) {
        await dispatch(fetchUserInfo());
        message.success('资料修改成功');
      } else {
        message.error(result?.error || '修改失败');
      }
    } catch (err) {
      message.error('修改失败');
    }
  };
  return (
    <Modal
      open={genderOpen}
      className="profileEditor-modal"
      centered
      width={480}
      title={<DialogHeading icon={<UserOutlined />} title="修改性别" description="你也可以选择不透露这项信息" />}
      okText="保存设置"
      cancelText="取消"
      okButtonProps={{ autoFocus: true, htmlType: 'submit' }}
      onCancel={() => setGenderOpen(false)}
      destroyOnHidden
      modalRender={dom => (
        <Form
          layout="vertical"
          form={genderForm}
          name="gender_form_in_modal"
          // 默认为用户原本信息，没有则置空
          initialValues={{ gender: userInfo?.gender || '' }}
          clearOnDestroy
          onFinish={values => onGenderCreate(values)}
        >
          {dom}
        </Form>
      )}
    >
      {/* 性别选择框 */}
      <Form.Item name="gender" label="性别">
        <Radio.Group className="profileEditor-genderOptions">
          <Radio.Button value="M">男</Radio.Button>
          <Radio.Button value="F">女</Radio.Button>
          <Radio.Button value="">不愿透露</Radio.Button>
        </Radio.Group>
      </Form.Item>
    </Modal>
  )
}

export default EditGenderModal;
